const en = {
  form: {
    transactionTime: 'Transaction Time',
    websiteName: 'Website', // 网站名称
    all: 'All',
    group: 'Group',
    logisticsCompany: 'Logistics company',
    uploadStatus: 'Upload Status',
    transactionId: 'Merchant Transaction ID', // 网站订单号
    trackingNumber: 'Tracking No.',
    logisticsCompanyURL: 'Logistics tracking URL',
    uploaded: 'Uploaded',
    not_uploaded: 'Not Uploaded',
    noLimited: 'No Limit',
    logisticsNumber: 'Tracking No.',
    goodsName: 'Goods name',
    logisticsCompanyName: 'Logistics company'
  },
  warning: {
    start: 'There are',
    end: 'non-uploaded transactions. To avoid affecting the withdrawal, please upload them in time.'
  },
  button: {
    search: 'Search',
    reset: 'Reset',
    upload: 'Bulk Upload',
    download: 'Template Download',
    export: 'Export current results',
    modify: 'Modify',
    uploadByOne: 'Upload',
    cancel: 'Cancel',
    confirm: 'Yes'
  },
  table: {
    orderidAndWebsiteName: 'Merchant Transaction ID/website',
    transactionTime: 'Transaction Time',
    uploadStatus: 'Upload Status',
    goodsName: 'Goods Name',
    orderidAndCompany: 'Tracking No./Logistics company',
    logisticsCompanyURL: 'Logistics tracking URL',
    uploadTime: 'Upload Time',
    operation: 'Operation',
    modify: 'Modify',
    uploadByOne: 'Upload',
    uploaded: 'Uploaded',
    notUploaded: 'Not Uploaded'
  },
  alert: {
    uploadTip: `Firstly, please click 'Export current results'; Secondly, add logistics information; Finally, upload the whole file. `,
    coverTip: 'There are transaction Ids with existing logistics information in the file. Are you sure to overwrite?',
    excTip: 'The following merchant transaction Ids in the file correspond to abnormal field value',
    notExit: 'The following merchant transaction Ids in the file is incorrect and does not exist.',
    moreTip: 'There is a lot of information abnormality in the file, please check and upload again.',
    moreNotExit: 'A large number of merchant transaction Ids in the file do not exist or do not need to upload logistics information, please check.',
    upload: 'Upload logistics information',
    modify: 'Modify logistics information',
    uploading: 'Data uploading, please wait, please do not refresh the page'
  }
}

export default en
